import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { CourseName } from '../components/admin/GeneralReport/TableSummaryReport/TableSummaryReport.types';
import { DEFAULT_API_CONFIG, TENANT_API_ENDPOINT } from '../utils/constants';

interface IGetCourseNamesParams {
  teamIds: string[];
}

export const coursesApi = createApi({
  reducerPath: 'coursesApi',
  // TODO: Figure out why we can't pass in the DEFAULT_API_CONFIG object into fetchBaseQuery directly
  baseQuery: fetchBaseQuery({
    baseUrl: DEFAULT_API_CONFIG.baseURL,
    timeout: DEFAULT_API_CONFIG.timeout,
    headers: DEFAULT_API_CONFIG.headers,
  }),
  endpoints: (builder) => ({
    getCourseNames: builder.query<CourseName[], unknown>({
      query: ({ teamIds }: IGetCourseNamesParams) => {
        return {
          url: `${TENANT_API_ENDPOINT}/authed/courses/names`,
          method: 'POST',
          body: {
            teamIds,
          },
        };
      },
    }),
  }),
});

export const { useGetCourseNamesQuery, useLazyGetCourseNamesQuery } = coursesApi;
